import { styled } from '@clickcease/cc-client-components-lib'
import * as Collapsible from '@radix-ui/react-collapsible'

export const SubMenuStyled = styled(Collapsible.Root, {
  marginTop: '$4',
})

export const SubMenuTrigger = styled(Collapsible.Trigger, {
  '@bp1': {
    width: '100%',
  },
})

export const SubMenuCollapsible = styled(Collapsible.Content, {
  width: '100%',
  '@bp1': {
    width: '100%',
  },
})

export const SubMenuMainCell = styled('span', {
  width: '194px',
  borderBottom: 'none',
  borderRadius: '$2',
  lineHeight: '44px',
  fontWeight: '$l',
  fontSize: '$md',
  display: 'flex',
  cursor: 'pointer',

  variants: {
    collapsed: {
      true: {
        padding: '$4 $2',
        width: '40px',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ['&.cell-active']: {
          borderBottom: 'none',
        },
      },
    },
    disabled: {
      true: {
        cursor: 'not-allowed',
        pointerEvents: 'none',
        color: '$neutral',
        '&:hover': {
          color: '$neutral',
          background: 'transparent',
        },
      },
    },
    isOpen: {
      true: {
        borderBottom: '0.5px solid $lightGray',
        borderRadius: '4px 4px 0 0',
      },
    },
    isActive: {
      true: {
        background: '$tableHovered',
        color: '$primaryColor',
      },
    },
    isCrossSale: {
      true: {
        borderBottom: 'none',
      },
    },
  },

  ['&:hover']: {
    color: '$primaryColor',
  },

  ['> svg']: {
    display: 'flex',
    alignSelf: 'center',
    width: '16px',
    height: '16px',
    marginLeft: '$6',
    marginRight: '$6',
  },

  '@bp1': {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export const MainCellText = styled('div', {
  variants: {
    collapsed: {
      true: {
        fontSize: '$xs',
        fontWeight: '$rb',
        lineHeight: '11px',
        textAlign: 'center',
        margin: '0px',
      },
    },
  },
})

export const SubMenuCellText = styled('span', {
  '@bp1': {
    marginLeft: '44px',
  },
})

export const SubMenuCell = styled('div', {
  background: '$tableHovered',
  color: '$primaryColor',
  height: '44px',
  lineHeight: '43px',
  padding: '0 20px',
  fontWeight: '$l',
  fontSize: '$md',
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  '@bp1': {
    width: '100%',
    padding: '0px',
  },

  variants: {
    cellActive: {
      true: {
        background: '$tableSelected',
        color: '$primaryColor',
      },
    },
  },

  ['&:hover']: {
    background: '$tableSelected',
  },

  ['&:last-of-type']: {
    borderBottomLeftRadius: '$2',
    borderBottomRightRadius: '$2',
  },
})
